// AIDEV-NOTE: dropbox-sign-exports; Factory and exports for Dropbox Sign service

import { DropboxSignService } from './dropbox-sign-service'
import { MockDropboxSignService } from './mock-dropbox-sign-service'
import type { ISignatureService } from '../types'

// Environment configuration
const USE_MOCK =
  process.env.NODE_ENV === 'development' &&
  !import.meta.env.VITE_DROPBOX_SIGN_API_KEY

// Factory function to create the appropriate service
export function createSignatureService(): ISignatureService {
  if (USE_MOCK) {
    return new MockDropboxSignService()
  }
  return new DropboxSignService()
}

// Singleton instance
export const signatureService = createSignatureService()

// Export services for testing
export { MockDropboxSignService, DropboxSignService }
